import { render, staticRenderFns } from "./ProductByUnitCards.vue?vue&type=template&id=2cbc9018&"
import script from "./ProductByUnitCards.vue?vue&type=script&lang=js&"
export * from "./ProductByUnitCards.vue?vue&type=script&lang=js&"
import style0 from "./ProductByUnitCards.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports